export default __webpack_public_path__ + "static/media/yellow1.fd6e7157.svg";